
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../../../../AppData/Roaming/nvm/v8.5.0/node_modules/preact-cli/lib/lib/webpack/async-component-loader.js??ref--9!../../../../../../AppData/Roaming/nvm/v8.5.0/node_modules/preact-cli/node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			});
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// C:/Users/Toni/AppData/Roaming/nvm/v8.5.0/node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/about/index.js
// module id = null
// module chunks = 